import { callApi, handleError, handleResponse } from '@helpers/api';

export * from './entities';

const deleteEntityRequest = agent => id => agent.delete(`auth/entity/${id}/`);
const createEntityRequest = agent => (payload, id) =>
  agent.post(`auth/entity/${id ? `?organization=${id}` : ''}`, payload);
const modifyEntityRequest =
  agent =>
  ({ id, ...payload }) =>
    agent.patch(`auth/entity/${id}/`, payload);

const listEntitiesByNameRequest =
  agent =>
  ({ name }) =>
    agent.get(`auth/entity/?search=${encodeURIComponent(name)}`);

const listEntitiesByIdRequest =
  agent =>
  ({ id }) =>
    agent.get(`auth/entity/${id}/`);

export const listEntitiesByName = async payload =>
  callApi(listEntitiesByNameRequest)(payload).then(handleResponse).catch(handleError);

export const listEntitiesById = async payload =>
  callApi(listEntitiesByIdRequest)(payload).then(handleResponse).catch(handleError);

export const createEntity = async payload =>
  callApi(createEntityRequest)(payload)
    .then(handleResponse)
    .catch(error => error);

export const modifyEntity = async (payload, orgId) =>
  callApi(modifyEntityRequest)(payload, orgId)
    .then(handleResponse)
    .catch(error => error);

export const deleteEntity = async id =>
  callApi(deleteEntityRequest)(id)
    .then(handleResponse)
    .catch(error => error);
